export const footer = {
    copyright: {
        label: "كل الحقوق محفوظة",
    },
};
